import api from "../Api.js";

export default () => {
  async function pesquisaVotada(publicKey) {
    return await api().get(
      `/pesquisa-satisfacao/is-pesquisa-votada/${publicKey}`
    );
  }

  async function perguntaPrincipalVotada(publicKey) {
    return await api().get(
      `/pesquisa-satisfacao/is-pesquisa-principal-votada/${publicKey}`
    );
  }

  async function getAllQuestion(publicKey) {
    return await api().get(`/pesquisa-satisfacao/questoes/${publicKey}`);
  }

  async function getMainQuestion(publicKey) {
    return await api().get(
      `/pesquisa-satisfacao/pergunta-principal/${publicKey}`
    );
  }

  async function answerAllQuestions(publicKey, question, idTicket) {
    return await api().post(
      `/pesquisa-satisfacao/questoes/${publicKey}`,
      question
    );
  }

  async function getPesquisasPendentes() {
    return await api().get("/pesquisa-satisfacao/pesquisa-pendentes");
  }

  async function verificaExistePesquisa() {
    return await api().get("/pesquisa-satisfacao/tem-pesquisa-pendentes");
  }

  return {
    pesquisaVotada,
    perguntaPrincipalVotada,
    getAllQuestion,
    getMainQuestion,
    answerAllQuestions,
    getPesquisasPendentes,
    verificaExistePesquisa
  };
};
